<div class="row mb-3 mx-3" *ngIf="(showCommonItems$ | async) && currentItem">
    <div class="progress-bar-container">
        <emm-progress-bar [isLoading$]="isLoading$"></emm-progress-bar>
    </div>

    <div class="col-12 d-flex justify-content-center">
        <div class="w-100" style="max-width: 1400px;">

            <!-- Readonly: Stacked layout -->
            <div class="readonly-width">
                <!-- Item details - Full width when readonly -->
                <div class="row">
                    <div class="col-12">
                        <mat-card class="mb-3">
                            <div class="d-flex flex-wrap">
                                <div>
                                    <mat-card-header class="p-4">
                                        <!-- Image and Content Row -->
                                        <div class="d-flex align-items-start">
                                            <div class="flex-shrink-0 me-4">
                                                <div class="detail-image" style="width: 120px; height: 120px;">
                                                    <img [src]="getDisplayImage()" alt="Avatar" class="img-fluid"
                                                         *ngIf="getDisplayImage(); else noImage"
                                                         style="width: 100%; height: 100%; object-fit: cover; border-radius: 8px;"/>
                                                    <ng-template #noImage>
                                                        <img alt="Default logo" width="37px" height="37px"
                                                             src="https://d4gii57lvoht3.cloudfront.net/images/CFA_Circle_Logo.png">
                                                    </ng-template>
                                                </div>
                                            </div>
                                            <div class="flex-grow-1 min-width-0">
                                                <mat-card-title class="text-truncate">{{ itemName }}</mat-card-title>
                                                <mat-card-subtitle class="mt-2">
                                                    <div
                                                        class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
                                                        <div class="d-flex align-items-center mb-1 mb-sm-0">
                                                            <span class="fw-bold me-2">Tag: </span>
                                                            <span class="me-2">
                                                            {{ itemTag }}
                                                        </span>
                                                            <button
                                                                mat-icon-button
                                                                size="small"
                                                                matTooltip="Copy tag"
                                                                (click)="copyTagToClipboard()">
                                                                <mat-icon>content_copy</mat-icon>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </mat-card-subtitle>
                                                <mat-card-subtitle class="mt-2 me-5 field-description">
                                                    <div class="text-break">{{ itemDescription }}</div>
                                                </mat-card-subtitle>
                                            </div>
                                        </div>
                                    </mat-card-header>
                                </div>
                            </div>

                            <mat-divider class="mb-3"></mat-divider>
                            <mat-card-content>
                                <mat-tab-group *ngIf="attributeGroups.length > 0">
                                    <mat-tab *ngFor="let group of attributeGroups" [label]="group">
                                        <div class="p-3">
                                            <form [formGroup]="form" *ngIf="formReady">
                                                <div class="form-section">
                                                    <div class="form-row mb-3"
                                                         *ngFor="let attribute of getAttributesByGroup(group)">
                                                        <div class="form-label mb-2">
                                                            <div class="field-name d-flex align-items-center">
                                                                {{ attribute.name }}
                                                                <span *ngIf="attribute.required"
                                                                      class="text-danger">*</span>
                                                            </div>
                                                        </div>
                                                        <hr>
                                                        <div class="form-input">
                                                            <mat-form-field
                                                                *ngIf="getFormControlType(attribute) === 'input'"
                                                                appearance="outline" class="w-75">
                                                                <input matInput
                                                                       [formControlName]="attribute.jsonProperty">
                                                            </mat-form-field>

                                                            <mat-form-field
                                                                *ngIf="getFormControlType(attribute) === 'number'"
                                                                appearance="outline" class="w-75">
                                                                <input matInput type="number"
                                                                       [formControlName]="attribute.jsonProperty">
                                                            </mat-form-field>

                                                            <mat-form-field
                                                                *ngIf="getFormControlType(attribute) === 'textarea'"
                                                                appearance="outline" class="w-75">
                                                                <textarea matInput
                                                                          [formControlName]="attribute.jsonProperty"
                                                                          rows="3"></textarea>
                                                            </mat-form-field>

                                                            <mat-checkbox
                                                                *ngIf="getFormControlType(attribute) === 'checkbox'"
                                                                [formControlName]="attribute.jsonProperty">
                                                                {{ attribute.name }}
                                                            </mat-checkbox>

                                                            <mat-form-field
                                                                *ngIf="getFormControlType(attribute) === 'select'"
                                                                appearance="outline" class="w-75">
                                                                <mat-select [formControlName]="attribute.jsonProperty">
                                                                    <mat-option
                                                                        *ngFor="let option of getAttributeOptions(attribute)"
                                                                        [value]="option.value ?? option">
                                                                        {{ option.label ?? option }}
                                                                    </mat-option>
                                                                </mat-select>
                                                            </mat-form-field>

                                                            <mat-form-field
                                                                *ngIf="getFormControlType(attribute) === 'multi-select'"
                                                                appearance="outline" class="w-75">
                                                                <mat-select [formControlName]="attribute.jsonProperty"
                                                                            multiple>
                                                                    <mat-option
                                                                        *ngFor="let option of getAttributeOptions(attribute)"
                                                                        [value]="option.value ?? option">
                                                                        {{ option.label ?? option }}
                                                                    </mat-option>
                                                                </mat-select>
                                                            </mat-form-field>
                                                            <button mat-icon-button type="button"
                                                                    class="image-preview-button"
                                                                    (click)="previewImage(attribute)"
                                                                    matTooltip="Preview this image"
                                                                    *ngIf="attribute.jsonProperty.toLowerCase().includes('image') && attribute.value">
                                                                <mat-icon>photo_frame</mat-icon>
                                                            </button>
                                                            <button mat-icon-button type="button"
                                                                    *ngIf="hasVariationOverride(attribute)"
                                                                    class="override-icon-btn"
                                                                    matTooltip="Value set by a variation override — click for details"
                                                                    (click)="openAttributeOverrideDialog(attribute)">
                                                                <img class="icon override-icon"
                                                                     ngSrc="assets/img/three-lanes.svg"
                                                                     alt="Three Lanes Icon" height="24" width="24"/>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </mat-tab>
                                </mat-tab-group>

                                <div *ngIf="attributeGroups.length === 0" class="text-center p-4">
                                    <p>No attribute groups found. Check if item has attributes.</p>
                                </div>

                                <!-- Created and Updated Dates -->
                                <div class="text-center mt-4 mb-3"
                                     *ngIf="currentItem?.createdDate || currentItem?.updatedDate || (variation$ | async)?.createdDate || (variation$ | async)?.updatedDate">
                                    <div *ngIf="(variation$ | async)?.variationLabel === 'Base Item'">
                                        <emm-created-date-display
                                            [createdDate]="currentItem?.createdDate"
                                            [createdBy]="currentItem?.createdBy">
                                        </emm-created-date-display>
                                        <emm-updated-date-display
                                            [updatedDate]="currentItem?.updatedDate"
                                            [updatedBy]="currentItem?.updatedBy">
                                        </emm-updated-date-display>
                                    </div>
                                    <div *ngIf="(variation$ | async)?.variationLabel !== 'Base Item'">
                                        <emm-created-date-display
                                            [createdDate]="(variation$ | async)?.createdDate"
                                            [createdBy]="(variation$ | async)?.createdBy">
                                        </emm-created-date-display>
                                        <emm-updated-date-display
                                            [updatedDate]="(variation$ | async)?.updatedDate"
                                            [updatedBy]="(variation$ | async)?.updatedBy">
                                        </emm-updated-date-display>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>

                <!-- Components - Stacked when readonly -->
                <div class="row">
                    <div class="col-12">
                        <emm-components-card
                            *ngIf="componentCardLabel"
                            [componentCardLabel]="componentCardLabel"
                            [components]="components$ | async"
                            [variation]="variation$ | async"
                            [itemName]="itemName"
                            [isReadOnly]="true"
                            [isLoading$]="isLoading$">
                        </emm-components-card>
                    </div>
                </div>

                <!-- Item Value Overrides - Stacked when readonly -->
                <div class="row" *ngIf="(item$ | async)?.itemValueOverrides?.length > 0">
                    <div class="col-12">
                        <emm-value-overrides-card
                            [overrides]="(item$ | async)?.itemValueOverrides"
                            [isLoading$]="isLoading$">
                        </emm-value-overrides-card>
                    </div>
                </div>
            </div>
            <br/>
            <br/>
            <br/>
            <br/>
        </div>
    </div>
</div>
